import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";

import {Calc, Coppia} from "@commons/mapping/Calc";
import {QualificaEccRecord} from "@commons/mapping/QualificaEccRecord";
import {QuantificaEccRecord} from "@commons/mapping/QuantificaEccRecord";
import {CachePresenze} from "@commons/mapping/CachePresenze";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";
import {FasciaOrariaGG} from "@commons/mapping/FasciaOrariaGG";
import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

interface Eccedenza {
    coppia: Coppia,
    minutiD: number,
    minutiN: number,
    tempoMaxSuperato: boolean
}

class Eccedenza {
    static factory: ObjectFactory<Eccedenza> = (json?) => {

        return merge<Eccedenza, Partial<Eccedenza> | undefined>({
            coppia: {} as Coppia,
            minutiD: 0,
            minutiN: 0,
            tempoMaxSuperato: false,
        }, json);
    }
}

export class OreEccedenti {
    static readonly defaultQuantificaEccSTD: Partial<QuantificaEccRecord> = {
        descrizione: 'Quantificazione x modalita\' STANDARD',
        tipoAbilitazione: 'DISABILITATA',
        regola: 'SINGOLA_TIMBRATURA',
        tempoMax: 1440,
        tempoMinimo: 1,
        multipliDi: 1,
        tempoBonus: 0,

        tempoMaxEntrata: 1440,
        tempoMinimoEntrata: 1,
        multipliDiEntrata: 1,
        tempoBonusEntrata: 0
    };

    private readonly tabQuantificaEcc: QuantificaEccRecord;
    private readonly tabQualificaEcc: QualificaEccRecord;
    private readonly distribuzioneTurno: TurnoDistribuzioneRecord;
    private readonly cache: CachePresenze;
    private eccedenze: any[];
    private eccedenzeNC: any[];

    constructor(tabQuantificaEcc: QuantificaEccRecord,
                tabQualificaEcc: QualificaEccRecord,
                distribuzioneTurno: TurnoDistribuzioneRecord,
                cache: CachePresenze) {

        this.tabQuantificaEcc = tabQuantificaEcc;
        this.tabQualificaEcc = tabQualificaEcc;
        this.distribuzioneTurno = distribuzioneTurno;
        this.cache = cache;
        this.eccedenze = [];
        this.eccedenzeNC = [];
    }

    public quantificaEccedente2 = (day: PresenzeGiornataPlusRecord, cFasciaDiurna: Calc, cFasciaNotturna: Calc, cPrevistoD: Calc, cPrevistoN: Calc, calcoloMassivo: boolean) => {
        day.totali!.hEccDiurne = 0;
        day.totali!.hEccNotturne = 0;
        day.totali!.hEccDiurneNC = 0;
        day.totali!.hEccNotturneNC = 0;
        this.eccedenze = [];
        this.eccedenzeNC = [];
        if (this.tabQuantificaEcc) {
            if (!calcoloMassivo) {
                console.log('Quantifico eccedenti con la tabella ' + this.tabQuantificaEcc.descrizione + ' [#' + this.tabQuantificaEcc.idTabella + ']');
            }

            let cEccedente = new Calc();
            cEccedente.add(cPrevistoD.getFlat());
            cEccedente.add(cPrevistoN.getFlat());
            cEccedente = cEccedente.invert();

            const coppieArr = PresenzeGiornataPlusRecord.getCopieArrotondate(day);
            const totalizzatore = new Calc();
            // raccolgo coppie utili al computo delle eccedenti
            for (let indA = 0; indA < coppieArr.length; ++indA) {
                totalizzatore.add(coppieArr[indA].calc.getFlat());
                //var minLav = copieArr[indA].calc.getCount(cEccedente);
                //copieArr[indA].daElaborare = (minLav > 0);

            }
            const minLav = totalizzatore.getFlatEcc(cEccedente);
            const intervalliLavorati: Coppia[] = [];
            {
                let coppia = null;
                for (let indLav = 0; indLav < minLav.length; ++indLav) {
                    if (minLav[indLav] > 0 && coppia === null) {
                        coppia = CoppiaTimbrature.factory();
                        const entrata = Calc.hhcc2hhmm((indLav / 60) * 100);
                        CoppiaTimbrature.setEntrata(coppia, entrata);
                    } else if (minLav[indLav] === 0 && coppia) {
                        const uscita = Calc.hhcc2hhmm(((indLav) / 60) * 100);
                        CoppiaTimbrature.setUscita(coppia, uscita);

                        intervalliLavorati.push(new Coppia(CoppiaTimbrature.getEntrata(coppia)!, CoppiaTimbrature.getUscita(coppia)!));
                        coppia = null;
                    }
                }

                if (coppia) {
                    // se copia è ancora istanziata significa che ho iterato tutto l'array senza trovare ulteriori elementi lavorati,
                    // quindi il lavoratore ha lavorato almeno fino a mezzanotte: chiudo manualmente l'intervallo settando le ore 24:00 (cioè 0!)
                    CoppiaTimbrature.setUscita(coppia, 0);
                    intervalliLavorati.push(new Coppia(CoppiaTimbrature.getEntrata(coppia)!, CoppiaTimbrature.getUscita(coppia)!));
                    coppia = null;
                }
            }

            for (let indLav = 0; indLav < intervalliLavorati.length; ++indLav) {
                const c = new Calc(intervalliLavorati[indLav]);
                let hEccDiurne = c.getCount(cFasciaDiurna);
                let hEccNotturne = c.getCount(cFasciaNotturna);

                let tempoMax = this.tabQuantificaEcc.tempoMax;
                let tempoMinimo = this.tabQuantificaEcc.tempoMinimo;
                let multipliDi = this.tabQuantificaEcc.multipliDi;
                if (day.qualificaEccNC) {
                    tempoMax = 0;
                    tempoMinimo = 1;
                    multipliDi = 1;
                } else {
                    // Determino se usare parametri per ecc. in ingresso o uscita
                    for (let indArr = 0; indArr < day.arrotondate.length; ++indArr) {
                        const coppia = day.arrotondate[indArr];
                        if (CoppiaTimbrature.getEntrata(coppia) === intervalliLavorati[indLav].getInizio()) {// HHMM
                            tempoMax = this.tabQuantificaEcc.tempoMaxEntrata;
                            tempoMinimo = this.tabQuantificaEcc.tempoMinimoEntrata;
                            multipliDi = this.tabQuantificaEcc.multipliDiEntrata;
                            break;
                        }
                    }
                }

                if (hEccDiurne + hEccNotturne >= tempoMinimo) {
                    const old_hEccDiurneNC = day.totali!.hEccDiurneNC;
                    const old_hEccNotturneNC = day.totali!.hEccNotturneNC;
                    const tempoMaxSuperato = this.normalizzaEccedenti(day, intervalliLavorati[indLav], multipliDi, tempoMinimo, tempoMax, cFasciaDiurna, cFasciaNotturna);
                    if (day.totali!.hEccDiurneNC > old_hEccDiurneNC || day.totali!.hEccNotturneNC > old_hEccNotturneNC) {
                        // Rilevo nuova fascia NC residua dopo primo step di normalizzazione
                        const eccedenza = Eccedenza.factory({coppia: intervalliLavorati[indLav]});
                        eccedenza.minutiD = day.totali!.hEccDiurneNC - old_hEccDiurneNC;
                        eccedenza.minutiN = day.totali!.hEccNotturneNC - old_hEccNotturneNC;
                        eccedenza.tempoMaxSuperato = tempoMaxSuperato;
                        this.eccedenzeNC.push(eccedenza);
                    }
                } else {
                    day.totali!.hEccDiurneNC += hEccDiurne;
                    day.totali!.hEccNotturneNC += hEccNotturne;
                    const eccedenza = Eccedenza.factory({coppia: intervalliLavorati[indLav]});
                    eccedenza.minutiD = hEccDiurne;
                    eccedenza.minutiN = hEccNotturne;
                    this.eccedenzeNC.push(eccedenza);
                }
            }
        }
    };

    public qualificaEccedente = (day: PresenzeGiornataPlusRecord,
                                 cFasciaDiurna: Calc,
                                 cFasciaNotturna: Calc,
                                 compensa: boolean, mancante: number,
                                 calcoloMassivo: boolean) => {
        const newCausali = []; // PresenzeCausali

        if (this.tabQualificaEcc) {

            const cancellaTuttiGliAutomatici = calcoloMassivo;
            this.cancelloEccedenteAutomatico(day, cancellaTuttiGliAutomatici);

            let hEccDiurneA = 0;
            let hEccNotturneA = 0;
            let hEccDiurneNA = 0;
            let hEccNotturneNA = 0;

            if (this.eccedenze.length > 0) {
                const scorporo = this.scorporaAmmessiNonAmmessi(day, this.eccedenze, calcoloMassivo, day.totali!.hEccDiurne, day.totali!.hEccNotturne, cFasciaDiurna, cFasciaNotturna);
                hEccDiurneA = scorporo.hEccDiurneA;
                hEccNotturneA = scorporo.hEccNotturneA;
                hEccDiurneNA = scorporo.hEccDiurneNA;
                hEccNotturneNA = scorporo.hEccNotturneNA;
            }
            if (this.eccedenzeNC.length > 0 && (this.tabQualificaEcc.tipoTabellaANA === 'QUALIFICA_NON_COMPUTABILE')) {
                for (let indEcc = 0; indEcc < this.eccedenzeNC.length; ++indEcc) {
                    const eccedenzaNC = this.eccedenzeNC[indEcc];
                    if (eccedenzaNC.tempoMaxSuperato) {
                        let minuti;
                        minuti = eccedenzaNC.coppia.calc.getCount(cFasciaDiurna);
                        hEccDiurneNA += Math.min(minuti, eccedenzaNC.minutiD);
                        minuti = eccedenzaNC.coppia.calc.getCount(cFasciaNotturna);
                        hEccNotturneNA += Math.min(minuti, eccedenzaNC.minutiN);
                    }
                }
                day.totali!.hEccDiurne += hEccDiurneNA;
                day.totali!.hEccNotturne += hEccNotturneNA;
                day.totali!.hEccDiurneNC -= hEccDiurneNA;
                day.totali!.hEccNotturneNC -= hEccNotturneNA;
            }

            /*
            this.tabQualificaEcc.generaWseA_FT = null; // Boolean
            this.tabQualificaEcc.generaWseNA_FT = null; // Boolean
            this.tabQualificaEcc.generaWseA_PT = null; // Boolean
            this.tabQualificaEcc.generaWseNA_PT = null; // Boolean
            */

            // Se presenza di mancante, verifico clausole di compensazione
            if (mancante > 0) {

                if (compensa || this.tabQualificaEcc.compensaScarti || this.tabQualificaEcc.compensaA || this.tabQualificaEcc.compensaNA) {

                    // NON COMPUTABILE
                    if (((compensa && this.tabQualificaEcc.compensaManualeScarti) || this.tabQualificaEcc.compensaScarti) && this.eccedenzeNC.length > 0) {
                        const scorporo = this.scorporaAmmessiNonAmmessi(day, this.eccedenzeNC, calcoloMassivo, day.totali!.hEccDiurneNC, day.totali!.hEccNotturneNC, cFasciaDiurna, cFasciaNotturna);

                        //scorporo.hEccDiurneA = this.tabQualificaEcc.compensaA ? scorporo.hEccDiurneA : 0;
                        //scorporo.hEccNotturneA = this.tabQualificaEcc.compensaA ? scorporo.hEccNotturneA : 0;
                        scorporo.hEccDiurneNA = this.tabQualificaEcc.compensaNA ? scorporo.hEccDiurneNA : 0;
                        scorporo.hEccNotturneNA = this.tabQualificaEcc.compensaNA ? scorporo.hEccNotturneNA : 0;

                        if (scorporo.getTotale() > 0) {
                            const result = this.compensaMancanti({
                                diurne: scorporo.hEccDiurneA + scorporo.hEccDiurneNA, //day.totali!.hEccDiurneNC,
                                notturne: scorporo.hEccNotturneA + scorporo.hEccNotturneNA, //day.totali!.hEccNotturneNC,
                                mancante: mancante
                            });
                            if (result.isCompensate()) {
                                mancante = result.mancante;
                                day.totali!.hEccDiurneNC -= result.oreCompensateD;
                                day.totali!.hEccNotturneNC -= result.oreCompensateN;
                                day.totali!.hOrdDiurne += result.oreCompensateD;
                                day.totali!.hOrdNotturne += result.oreCompensateN;

                                if (result.oreCompensateD > 0 && this.tabQualificaEcc.grCompensaGiornoNC) {
                                    const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grCompensaGiornoNC.codGiu!});
                                    PresenzeGiustificativo.setHHCC(causale, result.oreCompensateD / 60);
                                    newCausali.push(causale);
                                }
                                if (result.oreCompensateN > 0 && this.tabQualificaEcc.grCompensaNotteNC) {
                                    const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grCompensaNotteNC.codGiu!});
                                    PresenzeGiustificativo.setHHCC(causale, result.oreCompensateN / 60);
                                    newCausali.push(causale);
                                }

                                if (!compensa && this.tabQualificaEcc.generaWCompensaScarti) {
                                    PresenzeGiornataPlusRecord.setWarning(day, 8);
                                }
                            }
                        }
                    }

                    // COMPUTABILE NON AMMESSO
                    if (((compensa && this.tabQualificaEcc.compensaManualeNA) || this.tabQualificaEcc.compensaNA) && mancante > 0) {
                        const result = this.compensaMancanti({diurne: hEccDiurneNA, notturne: hEccNotturneNA, mancante: mancante});
                        if (result.isCompensate()) {
                            hEccDiurneNA = result.diurne;
                            hEccNotturneNA = result.notturne;
                            mancante = result.mancante;
                            day.totali!.hEccDiurne -= result.oreCompensateD;
                            day.totali!.hEccNotturne -= result.oreCompensateN;
                            day.totali!.hOrdDiurne += result.oreCompensateD;
                            day.totali!.hOrdNotturne += result.oreCompensateN;

                            if (result.oreCompensateD > 0 && this.tabQualificaEcc.grCompensaGiornoNA) {
                                const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grCompensaGiornoNA.codGiu!});
                                PresenzeGiustificativo.setHHCC(causale, result.oreCompensateD / 60);
                                newCausali.push(causale);
                            }
                            if (result.oreCompensateN > 0 && this.tabQualificaEcc.grCompensaNotteNA) {
                                const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grCompensaNotteNA.codGiu!});
                                PresenzeGiustificativo.setHHCC(causale, result.oreCompensateN / 60);
                                newCausali.push(causale);
                            }

                            if (!compensa && this.tabQualificaEcc.generaWCompensaNA) {
                                PresenzeGiornataPlusRecord.setWarning(day, 32);
                            }
                        }
                    }

                    // COMPUTABILE AMMESSO
                    if (((compensa && this.tabQualificaEcc.compensaManualeA) || this.tabQualificaEcc.compensaA) && mancante > 0) {
                        const result = this.compensaMancanti({diurne: hEccDiurneA, notturne: hEccNotturneA, mancante: mancante});
                        if (result.isCompensate()) {
                            hEccDiurneA = result.diurne;
                            hEccNotturneA = result.notturne;
                            mancante = result.mancante;
                            day.totali!.hEccDiurne -= result.oreCompensateD;
                            day.totali!.hEccNotturne -= result.oreCompensateN;
                            day.totali!.hOrdDiurne += result.oreCompensateD;
                            day.totali!.hOrdNotturne += result.oreCompensateN;

                            if (result.oreCompensateD > 0 && this.tabQualificaEcc.grCompensaGiornoA) {
                                const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grCompensaGiornoA.codGiu!});
                                PresenzeGiustificativo.setHHCC(causale, result.oreCompensateD / 60);
                                newCausali.push(causale);
                            }
                            if (result.oreCompensateN > 0 && this.tabQualificaEcc.grCompensaNotteA) {
                                const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grCompensaNotteA.codGiu!});
                                PresenzeGiustificativo.setHHCC(causale, result.oreCompensateN / 60);
                                newCausali.push(causale);
                            }

                            if (!compensa && this.tabQualificaEcc.generaWCompensaA) {
                                PresenzeGiornataPlusRecord.setWarning(day, 16);
                            }
                        }
                    }

                    // Verifico eventualmente nuovamente criteri di applicabilità
                    const totaleECC = day.totali!.hEccDiurne + day.totali!.hEccNotturne;
                    if (this.tabQuantificaEcc.compensa && totaleECC > 0) {
                        if (totaleECC < this.tabQuantificaEcc.tempoMinimo) {
                            day.totali!.hEccDiurneNC += day.totali!.hEccDiurne;
                            day.totali!.hEccNotturneNC += day.totali!.hEccNotturne;
                            hEccDiurneA = 0;
                            hEccNotturneA = 0;
                            hEccDiurneNA = 0;
                            hEccNotturneNA = 0;
                            day.totali!.hEccDiurne = 0;
                            day.totali!.hEccNotturne = 0;
                        }
                        let scarto = hEccDiurneA % this.tabQuantificaEcc.multipliDiEntrata;
                        if (scarto > 0) { // se non e' multiplo di...
                            day.totali!.hEccDiurneNC += scarto;
                            day.totali!.hEccDiurne -= scarto;
                            hEccDiurneA -= scarto;
                        }
                        scarto = hEccDiurneNA % this.tabQuantificaEcc.multipliDiEntrata;
                        if (scarto > 0) { // se non e' multiplo di...
                            day.totali!.hEccDiurneNC += scarto;
                            day.totali!.hEccDiurne -= scarto;
                            hEccDiurneNA -= scarto;
                        }
                        scarto = hEccNotturneA % this.tabQuantificaEcc.multipliDiEntrata;
                        if (scarto > 0) { // se non e' multiplo di...
                            day.totali!.hEccNotturneNC += scarto;
                            day.totali!.hEccNotturne -= scarto;
                            hEccNotturneA -= scarto;
                        }
                        scarto = hEccNotturneNA % this.tabQuantificaEcc.multipliDiEntrata;
                        if (scarto > 0) { // se non e' multiplo di...
                            day.totali!.hEccNotturneNC += scarto;
                            day.totali!.hEccNotturne -= scarto;
                            hEccNotturneNA -= scarto;
                        }
                    }

                    if (mancante === 0) {
                        PresenzeGiornataPlusRecord.setAnomalia(day, -3);
                    }
                    day.totali!.hMancanti = RiepilogoOrePlus.calcolaMancante(day.totali!, this.distribuzioneTurno);
                }
            }

            // Consumo ore con giustificativi caricati dall'utente...
            for (let indGiu = 0; indGiu < day.causaliHH.length; ++indGiu) {
                const causale = day.causaliHH[indGiu];
                if (causale && PresenzeGiustificativo.isValid(causale)) {
                    const giu = this.cache.getGiustificativo(causale.codGiu);
                    if (giu) {
                        let minutiCausale = causale.quantita * 60;
                        let minuti = 0;
                        switch (giu.tipoOreGiu) {
                            case 'E': // Eccedenti straordinarie diurne
                            case 'S': // Supplementari diurne
                                if (GiustificativoRecord.isAutomaticoEccNA(giu)) {
                                    minuti = Math.min(minutiCausale, hEccDiurneNA);
                                    hEccDiurneNA -= minuti;
                                    minutiCausale -= minuti;
                                }
                                if (minutiCausale > 0) {
                                    if (GiustificativoRecord.isAutomaticoEccA(giu)) {
                                        minuti = Math.min(minutiCausale, hEccDiurneA);
                                        hEccDiurneA -= minuti;
                                        minutiCausale -= minuti;
                                    }
                                }
                                break;

                            case 'N': // Eccedenti straordinarie notturne
                            case 'T': // Supplementari notturne
                                if (GiustificativoRecord.isAutomaticoEccNA(giu)) {
                                    minuti = Math.min(minutiCausale, hEccNotturneNA);
                                    hEccNotturneNA -= minuti;
                                    minutiCausale -= minuti;
                                }
                                if (minutiCausale > 0) {
                                    if (GiustificativoRecord.isAutomaticoEccA(giu)) {
                                        minuti = Math.min(minutiCausale, hEccNotturneA);
                                        hEccNotturneA -= minuti;
                                        minutiCausale -= minuti;
                                    }
                                }
                                break;
                        }
                    }
                }
            }

            if (hEccDiurneA > 0) {
                if (this.tabQualificaEcc.grFTgiornoA) {
                    const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grFTgiornoA.codGiu!});
                    PresenzeGiustificativo.setHHCC(causale, hEccDiurneA / 60);
                    newCausali.push(causale);
                    if (this.tabQualificaEcc.generaWseA_FT) {
                        PresenzeGiornataPlusRecord.setWarning(day, 64);
                    }
                } else {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 5);
                }
            }
            if (hEccDiurneNA > 0) {
                if (this.tabQualificaEcc.grFTgiornoNA) {
                    const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grFTgiornoNA.codGiu!});
                    PresenzeGiustificativo.setHHCC(causale, hEccDiurneNA / 60);
                    newCausali.push(causale);
                    if (this.tabQualificaEcc.generaWseNA_FT) {
                        PresenzeGiornataPlusRecord.setWarning(day, 128);
                    }
                } else {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 5);
                }
            }
            if (hEccNotturneA > 0) {
                if (this.tabQualificaEcc.grFTnotteA) {
                    const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grFTnotteA.codGiu!});
                    PresenzeGiustificativo.setHHCC(causale, hEccNotturneA / 60);
                    newCausali.push(causale);
                    if (this.tabQualificaEcc.generaWseA_FT) {
                        PresenzeGiornataPlusRecord.setWarning(day, 64);
                    }
                } else {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 5);
                }
            }
            if (hEccNotturneNA > 0) {
                if (this.tabQualificaEcc.grFTnotteNA) {
                    const causale = PresenzeGiustificativo.factory({codGiu: this.tabQualificaEcc.grFTnotteNA.codGiu!});
                    PresenzeGiustificativo.setHHCC(causale, hEccNotturneNA / 60);
                    newCausali.push(causale);
                    if (this.tabQualificaEcc.generaWseNA_FT) {
                        PresenzeGiornataPlusRecord.setWarning(day, 128);
                    }
                } else {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 5);
                }
            }
        }
        return newCausali;
    };

    /**
     * Normalizzo le ore di eccedenza, arrotondando al multiplo prestabilito
     * N.B. Si omette la verifica del raggiungimento del minimale, demandata al codice chiamante
     * N.B. la verifica del multiplo è fatta sul totale diurno e notturno (si pensi alla mezzora fatta a cavallo di fascia),
     * il totale normalizzato, viene ridiviso tra diurno e notturno secondo la priorità definita dalla prevalenza di una delle due grandezze.
     * N.B. aggiunge una nuova proprietà a copiaLav: tempoMaxSuperato vale true o false in base al superamento del massimale fissato per l'eccedenza
     * @param day
     * @param copiaLav
     * @param multipliDiEntrata
     * @param tempoMinimo
     * @param tempoMax
     * @param cFasciaDiurna
     * @param cFasciaNotturna
     */
    private normalizzaEccedenti = (day: PresenzeGiornataPlusRecord, copiaLav: Coppia, multipliDiEntrata: number, tempoMinimo: number, tempoMax: number, cFasciaDiurna: Calc, cFasciaNotturna: Calc) => {
        let tempoMaxSuperato: boolean;
        const hEccDiurne = copiaLav.calc.getCount(cFasciaDiurna);
        const hEccNotturne = copiaLav.calc.getCount(cFasciaNotturna);
        let hEcc = hEccDiurne + hEccNotturne; // totalizzo e applico multipli
        hEcc -= tempoMinimo;
        hEcc /= multipliDiEntrata;
        hEcc = Math.trunc(hEcc) * multipliDiEntrata;
        hEcc += tempoMinimo;

        if (tempoMax > 0 && hEcc > tempoMax) {
            hEcc = tempoMax;
            tempoMaxSuperato = true;
        } else {
            tempoMaxSuperato = false;
        }
        let newDiurne;
        let newNotturne;
        const diurnoPrevalente = (hEccDiurne >= hEccNotturne); // rilevo prevalenza
        if (diurnoPrevalente) {
            newDiurne = Math.min(hEccDiurne, hEcc); // prima diurno
            newNotturne = Math.min(hEccNotturne, hEcc - newDiurne); // poi notturno
        } else {
            newNotturne = Math.min(hEccNotturne, hEcc); // prima notturno
            newDiurne = Math.min(hEccDiurne, hEcc - newNotturne); // poi diurno
        }

        if (hEcc > 0) {
            const eccedenza = Eccedenza.factory({coppia: copiaLav});
            eccedenza.minutiD = newDiurne;
            eccedenza.minutiN = newNotturne;
            this.eccedenze.push(eccedenza);

            day.totali!.hEccDiurne += newDiurne;
            day.totali!.hEccNotturne += newNotturne;
        }

        day.totali!.hEccDiurneNC += (hEccDiurne - newDiurne);
        day.totali!.hEccNotturneNC += (hEccNotturne - newNotturne);
        return tempoMaxSuperato;
    };

    private scorporaAmmessiNonAmmessi = (day: PresenzeGiornataPlusRecord, eccedenze: Eccedenza[], calcoloMassivo: boolean,
                                         hEccDiurne: number, hEccNotturne: number, cFasciaDiurna: Calc, cFasciaNotturna: Calc) => {
        const scorporo = {
            hEccDiurneA: 0,
            hEccNotturneA: 0,
            hEccDiurneNA: 0,
            hEccNotturneNA: 0,
            getTotale: function () {
                return this.hEccDiurneA + this.hEccNotturneA + this.hEccDiurneNA + this.hEccNotturneNA;
            }
        };

        // Modifica del 12/11/2019, solo se tipo tabella NON AMMESSO oppure vi è un previsto, applico eventuale tabella Ammessi/NonAmmessi
        if (this.tabQualificaEcc.tipoTabellaANA === 'NON_AMMESSO' || (day.totali!.hPrevDiurne + day.totali!.hPrevNotturne > 0)) {
            if (!calcoloMassivo) {
                console.log('Qualifico eccedenti con la tabella ' + this.tabQualificaEcc.descrizione + ' [#' + this.tabQualificaEcc.idTabella + ']');
            }

            const fasce = this.tabQualificaEcc.tipoTabellaANA === 'NESSUN_CONTROLLO' ? [] : this.tabQualificaEcc.fasce;
            const copieFasce = [];
            for (let indF = 0; indF < fasce.length; ++indF) {
                const f = FasciaOrariaGG.factory(fasce[indF]);
                if (FasciaOrariaGG.isValid(f)) {
                    const coppia = new Coppia(FasciaOrariaGG.getInizio(f), FasciaOrariaGG.getFine(f));
                    copieFasce.push(coppia);
                }
            }

            switch (this.tabQualificaEcc.tipoTabellaANA) {
                case 'AMMESSO':
                    for (let indEcc = 0; indEcc < eccedenze.length; ++indEcc) {
                        const eccedenza = eccedenze[indEcc];
                        for (let indCF = 0; indCF < copieFasce.length; ++indCF) {
                            let minuti;
                            minuti = copieFasce[indCF].calc.getCount(eccedenza.coppia.calc, cFasciaDiurna);
                            scorporo.hEccDiurneA += Math.min(minuti, eccedenza.minutiD);
                            minuti = copieFasce[indCF].calc.getCount(eccedenza.coppia.calc, cFasciaNotturna);
                            scorporo.hEccNotturneA += Math.min(minuti, eccedenza.minutiN);
                        }
                    }
                    scorporo.hEccDiurneNA = hEccDiurne - scorporo.hEccDiurneA;
                    scorporo.hEccNotturneNA = hEccNotturne - scorporo.hEccNotturneA;
                    break;

                case 'NON_AMMESSO':
                    for (let indEcc = 0; indEcc < eccedenze.length; ++indEcc) {
                        const eccedenza = eccedenze[indEcc];
                        for (let indCF = 0; indCF < copieFasce.length; ++indCF) {
                            let minuti;
                            minuti = copieFasce[indCF].calc.getCount(eccedenza.coppia.calc, cFasciaDiurna);
                            scorporo.hEccDiurneNA += Math.min(minuti, eccedenza.minutiD);
                            minuti = copieFasce[indCF].calc.getCount(eccedenza.coppia.calc, cFasciaNotturna);
                            scorporo.hEccNotturneNA += Math.min(minuti, eccedenza.minutiN);
                        }
                    }
                    scorporo.hEccDiurneA = hEccDiurne - scorporo.hEccDiurneNA;
                    scorporo.hEccNotturneA = hEccNotturne - scorporo.hEccNotturneNA;
                    break;

                case 'NESSUN_CONTROLLO':
                default:
                    scorporo.hEccDiurneA = hEccDiurne;
                    scorporo.hEccNotturneA = hEccNotturne;
                    break;
            }
        } else {
            scorporo.hEccDiurneA = hEccDiurne;
            scorporo.hEccNotturneA = hEccNotturne;
        }
        return scorporo;
    };

    private cancelloEccedenteAutomatico = (day: PresenzeGiornataPlusRecord, tutti: boolean) => {
        // Cancello eventuali giustificativi con automatismo pari a <ta_eccedenteAutomatico> inseriti in precedenza
        for (let indGiu = 0; indGiu < day.causaliHH.length; ++indGiu) {
            const causale = day.causaliHH[indGiu];
            if (causale && causale.codGiu !== '') {
                if ((causale.idWF === null || causale.idWF === 0) && // Solo se giustificativo automatico o manuale ma non da WF!
                    !parseInt(causale.oraInizio!) && !parseInt(causale.oraFine!)) // e solo se causale NON da pianificazione!
                {
                    const giu = this.cache.getGiustificativo(causale.codGiu);
                    if (giu) {
                        if (GiustificativoRecord.isAutomaticoEccA(giu) || GiustificativoRecord.isAutomaticoEccNA(giu) || GiustificativoRecord.isAutomaticoComp(giu)) {
                            if (tutti || this.tabQualificaEcc === null || QualificaEccRecord.usaGiu(this.tabQualificaEcc, giu.codGiu!))
                                day.causaliHH[indGiu] = null;
                        }
                    }
                }
            }
        }
        day.causaliHH = PresenzeGiornataPlusRecord.defrag(day.causaliHH);
    };

    private compensaMancanti({diurne, notturne, mancante}: { diurne: number, notturne: number, mancante: number }) {
        const result = {
            diurne,
            notturne,
            mancante,
            oreCompensateD: 0,
            oreCompensateN: 0,
        };
        let hEcc = diurne + notturne;
        let oreCompensate = 0;
        if (hEcc > 0) {
            if ((hEcc - result.mancante) >= 0) {
                oreCompensate = result.mancante;
                hEcc -= result.mancante;
                result.mancante = 0;
            } else {
                oreCompensate = hEcc;
                result.mancante = result.mancante - hEcc;
                result.mancante = Math.round(result.mancante * 1000) / 1000;
                hEcc = 0;
            }

            if (result.diurne >= oreCompensate) {
                result.diurne = hEcc - result.notturne;
                result.oreCompensateD = oreCompensate;
                oreCompensate = 0;
            } else {
                result.oreCompensateD = result.diurne;
                oreCompensate -= result.oreCompensateD;
                result.diurne = 0;
            }
            if (oreCompensate > 0) {
                result.notturne -= oreCompensate;
                result.oreCompensateN = oreCompensate;
                oreCompensate = 0;
            }
        }
        return {
            ...result,
            isCompensate: () => (result.oreCompensateD + result.oreCompensateN) > 0
        };
    }

}